import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbPaginationModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { MasterInformationService } from '../../../Services/master-information.service';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { apiEndPoints } from '../../../api/apiEndPoint';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-version-status',
  standalone: true,
  imports: [NgFor, NgIf, FormsModule, CommonModule, NgbTooltip, ToastrModule, NgbPaginationModule],
  templateUrl: './version-status.component.html',
  styleUrl: './version-status.component.css'
})
export class VersionStatusComponent implements OnInit {

  // ---------------------- Pagination ---------------------- //
  page = 1;
  pageSize = 5;

  tableHeaders = ['User', 'User Name', 'Mobile No', 'City', 'Zone', 'Platform Type', 'Platform Version']

  tableData: any = [
    {
      userId: 'AB-001',
      userType: 'Individual requestor',
      userName: 'Arun',
      mobileNo: '1236547893',
      city: 'New york',
      zone: 'AlMadinah',
      platformType: 'IOS',
      notifications: '1.0.02'
    },
    {
      userId: 'AB-002',
      userType: 'Corporate requestor',
      userName: 'Manoj',
      mobileNo: '1236547893',
      city: 'Chicago',
      zone: 'AlAndulas',
      platformType: 'Android',
      notifications: '19.0.1'
    },
    {
      userId: 'AB-003',
      userType: 'Individual requestor',
      userName: 'Gugan',
      mobileNo: '1236547893',
      city: 'Francisco',
      zone: 'AlMadinah',
      platformType: 'Android',
      notifications: '19.0.2'
    },
    {
      userId: 'AB-004',
      userType: 'Corporate requestor',
      userName: 'Raja Vignesh',
      mobileNo: '1236547893',
      city: 'Houston',
      zone: 'AlAndulas',
      platformType: 'IOS',
      notifications: '1.0.01'
    }
  ];

  filteredData = [...this.tableData];
  activeFilterIndex: number | null = null;
  originalTableData: any;
  activeDropdown: any;
  versionList: any;

  constructor(private masterService: MasterInformationService, private toastr: ToastrService) {

  }

  // --------------------------------------- OnInit --------------------------------------- //

  ngOnInit() {
    this.getVersionStatus();
  }

  // --------------------------------------- GetVersion Status API --------------------------------------- //

  getVersionStatus() {
    this.masterService.getVersionStatus(apiEndPoints.onOffBuisness).subscribe({
      next: (response: any) => {
        this.versionList = response.body.details.filter((data: any) => data.userType != 'Admin');
        this.originalTableData = [...this.versionList];
      }
    })
  }

  // ----------------------------- Pagination ----------------------------- //

  get pagedData() {
    const start = (this.page - 1) * this.pageSize;
    const end = this.page * this.pageSize;
    return this.versionList?.slice(start, end);
  }

  onPageChange(page: number): void {
    this.page = page;
  }

  // --------------------------------------- Search Filter --------------------------------------- //

  onSearch(event: any) {
    const searchText = event.target.value.toLowerCase();

    if (!this.originalTableData) {
      this.originalTableData = [...this.versionList];
    }

    if (searchText) {
      this.versionList = this.originalTableData.filter((item: any) =>
        item.city?.toLowerCase().includes(searchText) ||
        item.username?.toLowerCase().includes(searchText) ||
        item.zone?.toLowerCase().includes(searchText) ||
        item.userType?.toLowerCase().includes(searchText) ||
        item.userPlatform?.toLowerCase().includes(searchText) ||
        item.platformVersion?.toLowerCase().includes(searchText)
      );
    } else {
      this.versionList = [...this.originalTableData];
    }
  }

  // ------------------------------- Export to Excel ------------------------------- //
  exportToExcel(): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.versionList);
    const wb: XLSX.WorkBook = { Sheets: { data: ws }, SheetNames: ['data'] };
    XLSX.writeFile(wb, 'VersionList.xlsx');
  }


  // --------------------------------------- Apply Filter --------------------------------------- //

  availableFilters: { [key: string]: string[] } = {
    'User Type': ['Individual requestor', 'Corporate requestor'],
    'City': ['New York', 'Francisco', 'Chicago', 'Houston'],
    'Zone': ['AlMadinah', 'AlAndulas'],
    'Platform Type': ['IOS', 'Android']
  };

  toggleDropdown(header: string): void {
    this.activeDropdown = this.activeDropdown === header ? null : header;
  }

  applyFilter(event: any, header: string): void {
    const selectedOption = event.target.innerText.trim();
    // Close the dropdown
    this.activeDropdown = null;

    const normalizedHeader = header.trim();

    if (!this.originalTableData) {
      this.originalTableData = [...this.filteredData];
    }

    if (selectedOption) {
      this.filteredData = this.originalTableData.filter((item: any) => {
        const value = item[normalizedHeader.toLowerCase()];
        return value && value.toLowerCase().includes(selectedOption.toLowerCase());
      });
    } else {
      this.filteredData = [...this.originalTableData];
    }
  }


  // -------------------------- Reset Filter -------------------------- //

  resetFilter() {
    this.filteredData = [];
    this.filteredData = [...this.tableData]
  }

}
